export default function firebaseReducer(state = null) {
  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/firebase.js